/* eslint-disable no-restricted-globals */
// CRA 표준 서비스워커 등록 헬퍼. onUpdate(새 버전 대기) 콜백으로 업데이트 배너를 띄운다.
// https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
  ),
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // PUBLIC_URL 이 다른 오리진이면 SW 동작 불가
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          // 로컬 개발 안내(콘솔)
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // 이미 대기중인 SW 가 있으면(이전 방문에서 받아둔 새 버전) 즉시 알림
      if (registration.waiting && navigator.serviceWorker.controller) {
        if (config && config.onUpdate) config.onUpdate(registration);
      }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // 새 콘텐츠가 받아져 대기중 — 업데이트 배너 표시
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              // 최초 설치(오프라인 캐시 준비 완료)
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
      // 열린 탭도 새 배포를 스스로 발견 — 10분 주기 + 탭 복귀 시 SW 갱신 점검.
      // (기존엔 페이지 재방문 시에만 감지 → 배포 잦은 날 오래 열린 탭이 구버전 고착)
      const checkUpdate = () => registration.update().catch(() => {});
      setInterval(checkUpdate, 10 * 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") checkUpdate();
      });
    })
    .catch((error) => {
      console.error("서비스워커 등록 실패:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      // 오프라인 — 무시
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
